import { Fragment, useEffect, useMemo, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import dayjs from 'dayjs';
import { TextFieldMask } from '../../../utils/TextfieldMask/TextfieldMask';
import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
  useTheme,
  Alert,
  TextField,
  Backdrop
} from '@mui/material';
import { campanhaTipo, leadOrigemStatus } from '../../../constants/crm';
import { DatePicker } from '@mui/x-date-pickers';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import LinkIcon from '@mui/icons-material/Link';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PeopleIcon from '@mui/icons-material/People';
import { carregarBaseConhecimento, deletarCampanha, salvarCampanha, setFormChange } from '../../../controllers/crm/campanhaController';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import QrCodeGenerator from './QrCode';

import 'dayjs/locale/pt-br';
import KnowledgeDetail from './Chatbot/KnowledgeDetail';
import { red, blue, green, grey } from '@mui/material/colors';
import { listenToCredito } from '../../../controllers/userController';

import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import WarningIcon from '@mui/icons-material/Warning';
import { pathLinkCampanha } from './linkCampanha';
import { Facebook, CheckCircle, ErrorOutline, Business, Campaign, WhatsApp } from '@mui/icons-material';

import { deleteMetaConfig, getMetaConfig, insertMetaConfig } from '../../../services/firebaseService';
import MetaSetupWizard from './MetaAuth/MetaSetupWizard';
import metaService from '../../../services/metaService';


dayjs.locale('pt-br');


export default function CampanhaDetails({ user, setShowCampanhaDetails, showCampanhaDetails,
  campanha, campanhas, setCampanhas, setSnackbar }) {

  if (process.env.REACT_APP_SHOWLOG === 'true') console.log('CampanhaDetails Rendered', user, campanha);

  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [loadingKnowledge, setLoadingKnowledge] = useState(false);
  const [savingCampanha, setSavingCampanha] = useState(false);
  const [deletingCampanha, setDeletingCampanha] = useState(false);
  const [nome, setNome] = useState('');
  const [dtinicio, setDtInicio] = useState(null);
  const [dtfim, setDtFim] = useState(null);
  const [origem, setOrigem] = useState('');
  const [tipo, setTipo] = useState('');
  const [link, setLink] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [showKnowledge, setShowKnowledge] = useState(false);
  const [openGIMO, setOpenGIMO] = useState(false);
  const [places, setPlaces] = useState([]);
  const [credito, setCredito] = useState(0);
  const [listenCredito, setListenCredito] = useState();
  const [consumo, setConsumo] = useState(0);
  const [knowledge, setKnowledge] = useState('');
  const [changeKnowledge, setChangeKnowledge] = useState(false);
  const [showQrCode, setShowQrCode] = useState(false);
  const [showMetaDetails, setShowMetaDetails] = useState(false);
  const [urlBase, setUrlBase] = useState();


  // Estados para Meta
  // const [showMetaAuth, setShowMetaAuth] = useState(false);
  const [showMetaRegistration, setShowMetaRegistration] = useState(false);
  const [metaAuthStatus, setMetaAuthStatus] = useState(null);
  const [metaData, setMetaData] = useState(null);

  // Novo state para controlar o loading específico do Meta
  const [loadingMeta, setLoadingMeta] = useState(false);
  const [showRevokeConfirmation, setShowRevokeConfirmation] = useState(false);

  // Estados de loading específicos
  const [savingMetaConfig, setSavingMetaConfig] = useState(false);
  const [revokingMeta, setRevokingMeta] = useState(false);

  // Computed loading state
  const isAnyLoading = loading || loadingKnowledge || savingCampanha || deletingCampanha || loadingMeta || savingMetaConfig || revokingMeta;

  // função para copiar o link para a memória
  function copyToClipboard() {
    navigator.clipboard.writeText(`${urlBase}/${link}`);
    setSnackbar({ open: true, message: 'Link copiado para a área de transferência', severity: 'success' });
  }

  function statusAuth(error) {
    return (
      <>
        {/* Status de Autenticação */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                bgcolor: metaAuthStatus === 'authenticated' ? green[50] :
                  metaAuthStatus === 'error' ? red[50] : grey[50],
                border: `1px solid ${metaAuthStatus === 'authenticated' ? green[200] :
                  metaAuthStatus === 'error' ? red[200] : grey[200]
                  }`
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {error ? (
                  <ErrorOutline color="error" />
                ) : metaAuthStatus === 'authenticated' ? (
                  <CheckCircle color="success" />
                ) : metaAuthStatus === 'error' ? (
                  <ErrorOutline color="error" />
                ) : (
                  <Business color="action" />
                )}
                <Typography variant="body2" fontWeight="medium">
                  Status:
                </Typography>
                <Chip
                  label={
                    error ? 'Não Configurado' : metaAuthStatus === 'authenticated' ? 'Configurado' :
                      metaAuthStatus === 'error' ? 'Erro' : 'Não Configurado'
                  }
                  color={
                    error ? 'error' : metaAuthStatus === 'authenticated' ? 'success' :
                      metaAuthStatus === 'error' ? 'error' : 'default'
                  }
                  size="small"
                  sx={{ fontWeight: 'bold' }}
                />
              </Box>
              <Button
                variant={metaAuthStatus === 'authenticated' ? 'outlined' : 'contained'}
                size="small"
                color="primary"
                onClick={() => setShowMetaRegistration(true)}
                startIcon={<Facebook />}
                disabled={isAnyLoading}
              >
                {metaAuthStatus === 'authenticated' ? 'Reconfigurar' : 'Configurar Meta'}
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </>
    )
  }

  function handleOpenGIMO() {
    setOpenGIMO(true);
  }

  // Funções para Meta  

  const handleMetaDataChange = (field, value) => {
    setMetaData(prev => ({
      ...prev,
      [field]: value
    }));
    // console.log("Meta data updated:", metaData);
  };

  async function revogarApp(pageId, accessToken, formId) {
    try {
      setRevokingMeta(true);

      // Primeiro revoga a inscrição do app na página Meta
      const revogarResult = await metaService.unSubscribePage(pageId, accessToken);

      if (revogarResult.success) {
        // Se a revogação foi bem-sucedida, apagar o documento no Firebase
        try {
          await deleteMetaConfig(formId);
          setMetaAuthStatus(null);
          setShowMetaDetails(true);
          setMetaData(null);
          setSnackbar({
            open: true,
            message: 'App revogado e configuração Meta removida com sucesso',
            severity: 'success'
          });

          // Atualize a campanha para remover a referência ao formId
          const updatedCampanha = {
            ...campanha,
            idmetaform: null
          };

          // Se necessário, atualizar a campanha no backend também
          const saveCampanhaResult = await salvarCampanha(user, updatedCampanha);

          if (saveCampanhaResult.status === 200) {
            // Atualiza o objeto da campanha local
            campanha.idmetaform = null;
            campanha.version = saveCampanhaResult.data.version;

            // Atualiza a lista de campanhas
            const updatedCampanhas = campanhas.map(c =>
              c.idcampanha === campanha.idcampanha ? { ...c, idmetaform: null, version: saveCampanhaResult.data.version } : c
            );
            setCampanhas(updatedCampanhas);
          }

          return { success: true };
        } catch (error) {
          console.error("Erro ao apagar configuração Meta:", error);
          setSnackbar({
            open: true,
            message: `Inscrição revogada, mas ocorreu um erro ao remover a configuração: ${error.message}`,
            severity: 'warning'
          });
          return { success: false, error: error.message };
        }
      } else {
        setSnackbar({
          open: true,
          message: `Erro ao revogar app: ${revogarResult.error.message}`,
          severity: 'error'
        });
        return { success: false, error: revogarResult.error };
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: `Erro ao revogar app: ${error.message}`,
        severity: 'error'
      });
      return { success: false, error: error.message };
    } finally {
      setRevokingMeta(false);
    }
  }



  async function handleCampanhaFormChange(idmetaform, idcampanha) {
    const campanhaChangeForm = [];
    campanhas.forEach(c => {
      if (c.idmetaform === idmetaform && c.idcampanha !== idcampanha) {
        c.changeform = true;
        campanhaChangeForm.push(c.idcampanha);
      } else {
        c.changeform = false;
      }
    });
    setCampanhas([...campanhas]);
    return campanhaChangeForm.length > 0 ? campanhaChangeForm : false;
  }

  // Função para lidar com o sucesso do registro Meta
  const handleMetaRegistrationSuccess = async (registrationData) => {
    try {
      setSavingMetaConfig(true);
      // console.log('Registro Meta concluído:', metaData);
      setShowMetaRegistration(false);

      const registrarApp = await metaService.subscribePage(
        metaData.pageId,
        metaData.accessToken
      );


      if (registrarApp.success) {
        // Criar um objeto campanha temporário com os dados atualizados
        const campanhaAtualizada = {
          ...campanha,
          idmetaform: metaData.formId,
          changeform: (metaData.campanhaId !== campanha.idcampanha)
        };

        // Atualizar os estados locais com os novos dados
        const idcampanha = campanhaAtualizada?.idcampanha ? campanhaAtualizada.idcampanha : null;

        const campanhaData = {
          idcampanha: campanha.idcampanha || null,
          nome: nome,
          idoperador: user.id,
          idconta: user.conta,
          dtinicio: dayjs(dtinicio).toISOString(),
          dtfim: dayjs(dtfim).toISOString(),
          origem: origem,
          tipo: tipo,
          link: link,
          idusuario: user.id,
          knowledge: knowledge,
          idmetaform: metaData.formId,
          changeform: (metaData.campanhaId !== campanha.idcampanha),
          version: campanha?.version ? campanha.version : 0,
        };

        // Chamar diretamente salvarCampanha com os dados atualizados
        const result = await salvarCampanha(user, campanhaData);

        if (result.status === 200) {
          // Atualizar o objeto campanha
          campanha.idmetaform = result.data.idmetaform || metaData.formId;
          campanha.changeform = result.data.changeform || false;
          campanha.version = result.data.version || 0;
          // Salvar a configuração Meta no Firebase
          if (await insertMetaConfig(metaData)) {
            // if (campanha.tipo === campanhaTipo.META && metaData) {
            // console.log('Mudança de ConfigMeta:', metaData);
            const alterar = await handleCampanhaFormChange(metaData.formId, idcampanha);
            if (alterar) {
              const result = await setFormChange(user.conta, campanha.idcampanha, campanha.idmetaform, alterar);
              // console.log('Alterar Form', result);
              if (result) {
                setSnackbar({ open: true, message: 'Formulário alterado com sucesso', severity: 'success' });
              } else {
                setSnackbar({ open: true, message: 'Erro ao alterar formulário', severity: 'error' });
              }
            }

            // Atualizar o array campanhas com a campanha modificada
            const updatedCampanhas = campanhas.map(c =>
              c.idcampanha === campanha.idcampanha ? { ...campanha } : c
            );
            setCampanhas(updatedCampanhas);
            setMetaAuthStatus('authenticated');
            setSnackbar({
              open: true,
              message: 'Configuração Meta salva com sucesso!',
              severity: 'success'
            });
          }
          else {
            setSnackbar({
              open: true,
              message: 'Erro ao salvar configuração Meta',
              severity: 'error'
            });
          }

        } else {
          setMetaAuthStatus(null);
          setSnackbar({
            open: true,
            message: 'Erro ao salvar campanha: Campanha não foi salva',
            severity: 'error'
          });
        }
      } else {
        setMetaAuthStatus(null);
        setSnackbar({
          open: true,
          message: 'Falha ao registrar aplicação! Verifique as informações fornecidas e tente novamente mais tarde.',
          severity: 'error'
        });
      }
    } catch (error) {
      console.error('Erro ao registrar Meta:', error);
      setMetaAuthStatus('error');
      setSnackbar({
        open: true,
        message: `Erro ao registrar Meta: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setSavingMetaConfig(false);
    }
  };

  // Funções Interface
  // Função para lidar com a troca de tipo de campanha
  function handleChangeTipo(e) {
    const _tipo = e.target.value
    setTipo(e.target.value);
    if (link) {
      const linkArray = link.split('/');
      linkArray[linkArray.length - 1] = e.target.value;
      setLink(linkArray.join('/'));
    }
    setUrlBase(pathLinkCampanha({ tipo: _tipo, link: link }));
    if (_tipo !== campanhaTipo.META) {
      setShowMetaDetails(false);
      setShowMetaRegistration(false);
      if (e.target.value === "ChatBot") { setChangeKnowledge(true); }
    } else {
      setChangeKnowledge(false);
      setShowMetaDetails(true);
      handleMetaDataChange('track', link);
      // Mostrar MetaRegistrationStepper se não há dados Meta configurados
      if (!metaAuthStatus || metaAuthStatus !== 'authenticated') {
        setShowMetaRegistration(true);
      }
    }

    return false;
  }

  // Função para lidar com a mudança de origem
  function handleChangeOrigem(e) {

    setOrigem(e.target.value);

    if (link) {
      const linkArray = link.split('/');
      linkArray[linkArray.length - 2] = e.target.value;
      setLink(linkArray.join('/'));

    }
    return false; // Prevent default behavior
  }
  // Função para validar os campos

  function validateCampanha() {
    if (nome === '' || nome === null || nome === undefined) {
      setSnackbar({ open: true, message: 'Nome da campanha não pode estar vazio', severity: 'error' });
      return false;
    }
    if (dtinicio === null || !dayjs(dtinicio).isValid()) {  // Updated validation
      setSnackbar({ open: true, message: 'Data de início não pode estar vazia', severity: 'error' });
      return false;
    }
    if (dtfim === null || !dayjs(dtfim).isValid()) {  // Updated validation
      setSnackbar({ open: true, message: 'Data de fim não pode estar vazia', severity: 'error' });
      return false;
    }
    if (origem === '' || origem === null || origem === undefined) {
      setSnackbar({ open: true, message: 'Canal não pode estar vazio', severity: 'error' });
      return false;
    }
    if (tipo === "ChatBot" && (knowledge === '' || knowledge === null || knowledge === undefined)) {
      setSnackbar({ open: true, message: 'Defina a Base de Conhecimento para o GIMO...', severity: 'error' });
      return false;
    }
    if (tipo === '' || tipo === null || tipo === undefined) {
      setSnackbar({ open: true, message: 'Tipo não pode estar vazio', severity: 'error' });
      return false;
    }
    return true;
  }

  // Função para salvar as alterações
  async function saveCampanha() {
    if (!validateCampanha()) return;
    setSavingCampanha(true);
    const idcampanha = campanha?.idcampanha ? campanha.idcampanha : null;

    // console.log('Meta Data Salvar:', metaData);
    const campanhaData = {
      idcampanha: idcampanha,
      nome: nome,
      idoperador: user.id,
      idconta: user.conta,
      dtinicio: dayjs(dtinicio).toISOString(),
      dtfim: dayjs(dtfim).toISOString(),
      origem: origem,
      tipo: tipo,
      link: link,
      idusuario: user.id,
      knowledge: knowledge,
      idmetaform: metaData?.formId || campanha?.idmetaform || '',
      changeform: (metaData?.campanhaId !== campanha.idcampanha),
      version: campanha?.version ? campanha.version : 0,
      canwhatsmsg: user.canwhatsmsg ? true : false
    };

    const result = await salvarCampanha(user, campanhaData);

    if (result.status === 200) {
      setChangeKnowledge(false);
      campanha.idcampanha = result.data.idcampanha;
      campanha.nome = result.data.nome;
      campanha.dtinicio = result.data.dtinicio;
      campanha.dtfim = result.data.dtfim;
      campanha.origem = result.data.origem;
      campanha.link = result.data.link;
      campanha.version = result.data.version;
      campanha.updatedat = result.data.updatedat;
      campanha.tipo = result.data.tipo;
      campanha.idmetaform = result.data.idmetaform || null;
      campanha.changeform = result.data.changeform || false;
      campanha.canwhatsmsg = result.data.canwhatsmsg || false;
      setLink(result.data.link);

      if (idcampanha === null) { // Insert
        campanhas.push(campanha);
      }
      setSnackbar({ open: true, message: 'Campanha salva com sucesso', severity: 'success' });
      setSavingCampanha(false);
      return true;
    } else if (result.status === 210) {
      setSnackbar({ open: true, message: 'Acesso concorrente, recarregue os dados.', severity: 'error' });
      setSavingCampanha(false);
      return false;
    } else {
      setSnackbar({ open: true, message: 'Erro ao salvar campanha' + result.message, severity: 'error' });
      setSavingCampanha(false);
      return false;
    }
  }

  async function deleteCampanha() {
    setDeletingCampanha(true);
    if (campanha.tipo === campanhaTipo.META && metaData) {
      if (campanha.idmetaform && metaData.campanhaId === campanha.idcampanha) {
        try {
          await deleteMetaConfig(campanha.idmetaform);
          setSnackbar({ open: true, message: 'Configuração Meta deletada com sucesso', severity: 'success' });
        } catch (error) {
          console.error('Erro ao deletar configuração Meta:', error);
          setSnackbar({ open: true, message: 'Erro ao deletar configuração Meta', severity: 'error' });
        }
      }
    }
    const result = await deletarCampanha({ idcampanha: campanha.idcampanha, version: campanha.version });
    if (result.status === 200) {

      setSnackbar({ open: true, message: 'Campanha deletada com sucesso', severity: 'success' });
      const newCampanhas = campanhas.filter(camp => camp.idcampanha !== campanha.idcampanha);
      setCampanhas(newCampanhas);
      setShowCampanhaDetails(false);
    }
    else if (result.status === 210) {
      setSnackbar({ open: true, message: 'Acesso concorrente, recarregue os dados.', severity: 'error' });
    }
    else if (result.status === 220) {
      setSnackbar({ open: true, message: 'Campanha não pode ser deletada pois possui leads associados.', severity: 'error' });
    }
    else {
      setSnackbar({ open: true, message: 'Erro ao salvar campanha', severity: 'error' });
    }
    setDeletingCampanha(false);
  }

  // Carregar a base de conhecimento

  async function loadBaseConhecimento(user, idcampanha) {
    setLoadingKnowledge(true);
    const result = await carregarBaseConhecimento(user, idcampanha);
    if (result) {
      setKnowledge(result.know);
    }
    else {
      setKnowledge(null);
    }
    setLoadingKnowledge(false);
  }

  useEffect(() => {
    if (tipo === "ChatBot") {
      setShowKnowledge(true);
    } else {
      setShowKnowledge(false);
    }
  }, [tipo]);

  const handleCreditoUpdate = (result) => {
    if (result.success) {
      setCredito(result.credito);
    } else {
      setSnackbar({ open: true, message: result.message, severity: 'error' });
    }
  };

  useEffect(() => {
    const loadMetaConfig = async () => {
      if (campanha.idmetaform) {
        setLoadingMeta(true);
        try {
          const config = await getMetaConfig(campanha.idmetaform);
          if (config) {
            setMetaData({
              appId: config?.appId || '',
              form: config?.form || '',
              formId: config?.formId || '',
              page: config?.page || '',
              pageId: config?.pageId || '',
              pixelId: config?.pixelId || '',
              track: config?.track || '',
              campanhaId: config?.campanhaId || '',
              campanha: config?.campanha || '',
              accessToken: config?.accessToken || '',
              userAccessToken: config?.userAccessToken || '',
              tokenApiConversion: config?.tokenApiConversion || ''
            });
            // console.log('form <> Campanha:', config.campanhaId, campanha.idcampanha, config.campanhaId !== campanha.idcampanha);
            setMetaAuthStatus('authenticated');
            setShowMetaDetails(true);
          } else {
            setMetaAuthStatus(null);
            setShowMetaDetails(true);
            setMetaData(null);
            setShowMetaRegistration(true);
          }
        } catch (error) {
          console.error('Erro ao carregar configuração Meta:', error);
          setMetaData(null);
        } finally {
          setLoadingMeta(false);
        }
      }
      else {
        setMetaAuthStatus(null);
        setMetaData(null);
        setShowMetaDetails(true);
        setShowMetaRegistration(true);
      }
    };

    if (campanha) {
      setLoading(true);
      setNome(campanha.nome || '');
      setDtInicio(campanha.dtinicio ? dayjs(campanha.dtinicio) : null);
      setDtFim(campanha.dtfim ? dayjs(campanha.dtfim) : null);
      setOrigem(campanha.origem || '');
      setLink(campanha.link || '');
      setConsumo(campanha.consumo || 0);
      setCredito(user.credito || 0);
      setTipo(campanha.tipo || '');

      if (campanha.tipo === campanhaTipo.ChatBot) {
        loadBaseConhecimento(user, campanha.idcampanha);
      }
      if (campanha.tipo === campanhaTipo.META) {
        loadMetaConfig(); // Chamando a função assíncrona
      }

      setUrlBase(pathLinkCampanha(campanha));
      setLoading(false);
    }

    const subscription = listenToCredito(user, handleCreditoUpdate);
    return () => subscription();
  }, []);

  useEffect(() => {
    // Apply focus handling during loading state
    if (isAnyLoading) {
      // Create a div to hold focus during loading
      const focusHolder = document.createElement('div');
      focusHolder.tabIndex = -1;
      document.body.appendChild(focusHolder);
      focusHolder.focus();

      return () => {
        // Clean up when loading is done
        if (document.body.contains(focusHolder)) {
          document.body.removeChild(focusHolder);
        }
      };
    }
  }, [isAnyLoading]);

  const handleClose = () => {
    setShowCampanhaDetails(false);
  };

  return (
    <Fragment>
      <Dialog
        open={showCampanhaDetails}
        onClose={!isAnyLoading ? handleClose : undefined}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullScreen={window.innerWidth < 600}
        disableEscapeKeyDown={isAnyLoading}
        keepMounted={isAnyLoading} // Keep dialog mounted during loading
        PaperProps={{
          elevation: 3,
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            bgcolor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          DETALHES DA CAMPANHA
          {isAnyLoading && (
            <CircularProgress size={20} sx={{ color: 'inherit' }} />
          )}
        </DialogTitle>

        <DialogContent
          sx={{ mt: 2, pt: 3, pb: 1, px: 3, position: 'relative' }}
          // Add inert attribute conditionally
          {...(isAnyLoading ? { inert: 'true' } : {})}
        >
          {/* Loading Backdrop */}
          <Backdrop
            sx={{
              position: 'absolute',
              zIndex: (theme) => theme.zIndex.drawer + 1,
              backgroundColor: 'rgba(255,255,255,0.8)',
              backdropFilter: 'blur(2px)'
            }}
            open={isAnyLoading}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2
              }}
            >
              <CircularProgress size={60} />
              <Typography variant="body1" color="primary" fontWeight="medium">
                {loading && 'Carregando dados da campanha...'}
                {loadingKnowledge && 'Carregando base de conhecimento...'}
                {savingCampanha && 'Salvando campanha...'}
                {deletingCampanha && 'Deletando campanha...'}
                {loadingMeta && 'Carregando configuração Meta...'}
                {savingMetaConfig && 'Salvando configuração Meta...'}
                {revokingMeta && 'Revogando app Meta...'}
              </Typography>
            </Box>
          </Backdrop>

          <Grid container spacing={2} maxWidth={600} py={1}>
            {/* Nome da Campanha */}
            <Grid item xs={12}>
              <TextFieldMask
                fullWidth
                variant='outlined'
                size='small'
                id="nome"
                name='nome'
                label="Nome da Campanha"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                mask={'text'}
                disabled={isAnyLoading}
              />
            </Grid>

            {/* Data Início e Fim */}
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="Data de Início"
                value={dtinicio}
                onChange={(date) => setDtInicio(date)}
                format='DD/MM/YYYY'
                disabled={isAnyLoading}
                slotProps={{ textField: { size: 'small', fullWidth: true } }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="Data de Fim"
                value={dtfim}
                onChange={(date) => setDtFim(date)}
                format='DD/MM/YYYY'
                disabled={isAnyLoading}
                slotProps={{ textField: { size: 'small', fullWidth: true } }}
              />
            </Grid>

            {/* Canal e Tipo */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="lbOrigem">Canal</InputLabel>
                <Select
                  labelId="lbOrigem"
                  id="origem"
                  value={origem || ''}  // Add fallback value
                  onChange={handleChangeOrigem}
                  label="Canal"
                  disabled={isAnyLoading}
                  sx={{ height: '40px' }}
                >
                  <MenuItem value=""><em>Nenhum</em></MenuItem>
                  {leadOrigemStatus && Object.keys(leadOrigemStatus).map((key) => (
                    key !== 'Description' &&
                    <MenuItem key={key} value={key}>
                      {key}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="lbTipo">Tipo</InputLabel>
                <Select
                  labelId="lbTipo"
                  id="tipo"
                  // Add fallback value
                  onChange={handleChangeTipo}
                  label="Tipo"
                  disabled={isAnyLoading}
                  sx={{ height: '40px' }}
                  value={tipo || ''}
                >
                  <MenuItem value=""><em>Nenhum</em></MenuItem>
                  {campanhaTipo && Object.keys(campanhaTipo)
                    // .filter((key) => {
                    //   // Insert META option for gate51.com.br users
                    //   if (!user.email.includes('gate51.com.br') && key === campanhaTipo.META) return false;
                    //   return true;
                    // })
                    .map((key) => (
                      <MenuItem key={key} value={key}>
                        {key}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Botão GIMO - IA */}
            {showKnowledge && (
              <Grid item xs={12} container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <Button
                    disabled={isAnyLoading}
                    color={knowledge ? 'success' : 'primary'}
                    fullWidth
                    variant='contained'
                    onClick={handleOpenGIMO}
                    sx={{
                      py: 1.2,
                      fontWeight: 'bold',
                      boxShadow: 3
                    }}
                  >
                    {loadingKnowledge ? (
                      <>
                        <CircularProgress size={16} sx={{ mr: 1 }} />
                        Carregando...
                      </>
                    ) : (
                      'GIMO - Base de Conhecimento'
                    )}
                  </Button>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper
                    elevation={1}
                    sx={{
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      bgcolor: grey[100]
                    }}
                  >
                    <Typography variant="body2" fontWeight="medium">
                      Consumo de Tokens:
                    </Typography>
                    <Chip
                      label={consumo}
                      color="primary"
                      size="small"
                      sx={{ fontWeight: 'bold' }}
                    />
                  </Paper>
                </Grid>
              </Grid>
            )}
            {/* Link para copiar */}
            {(campanha.link && !showMetaDetails) && (
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <LinkIcon color="primary" /> Link da Campanha
                  </Typography>
                  <Paper
                    elevation={1}
                    sx={{
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      bgcolor: blue[50],
                      border: `1px solid ${blue[200]}`,
                      borderRadius: 1
                    }}
                  >
                    <Box sx={{ overflow: 'auto', flexGrow: 1 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: 'monospace',
                          wordBreak: 'break-all'
                        }}
                      > {`${urlBase}/${link}`}
                      </Typography>
                    </Box>
                    <Stack direction="row" >
                      <IconButton
                        onClick={copyToClipboard}
                        color="primary"
                        disabled={isAnyLoading}
                        sx={{ ml: 0.5 }}
                        title="Copiar link"
                      >
                        <ContentCopyTwoToneIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => setShowQrCode(true)}
                        color="primary"
                        disabled={isAnyLoading}
                        sx={{ ml: 1 }}
                        title="QR Code"
                      >
                        <QrCode2Icon />
                      </IconButton>
                      <IconButton
                        onClick={() => window.open(`${urlBase}/${link}`, '_blank')}
                        color="primary"
                        disabled={isAnyLoading}
                        sx={{ ml: 1 }}
                        title="Abrir link"
                      >
                        <OpenInNewIcon />
                      </IconButton>
                    </Stack>
                  </Paper>
                </Box>
              </Grid>
            )}
            {showMetaDetails && !showMetaRegistration && (
              <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <Facebook color="primary" /> Configurações Meta
                  </Typography>

                  {/* {!metaAuthStatus && statusAuth(false)} */}
                  {loadingMeta ? (
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 2,
                      py: 4
                    }}>
                      <CircularProgress size={40} />
                      <Typography variant="body2" color="textSecondary">
                        Carregando configurações Meta...
                      </Typography>
                    </Box>
                  ) : (
                    metaAuthStatus === 'authenticated' && (
                      <Grid container spacing={2}>

                        {/* Informações da configuração */}
                        {metaData.campanhaId !== campanha.idcampanha ? (
                          <Grid item xs={12}>
                            <Alert severity="warning" sx={{ mb: 2 }}>
                              <Typography variant="body2" fontWeight="medium">
                                Atenção: O Formulário Meta não está mais vinculado à campanha atual.
                              </Typography>
                              <Typography variant="body2">
                                Campanha vinculada: {metaData.campanha || 'Não configurada'}
                              </Typography>
                              <Typography variant="body2">
                                Configure um formulário Meta para esta campanha.
                              </Typography>
                            </Alert>
                            {statusAuth(true)}
                          </Grid>
                        ) : (
                          <>
                            <Grid item xs={12}>
                              {statusAuth(false)}
                              <Alert severity="success" sx={{ mb: 2 }}>
                                <Typography variant="body2" fontWeight="medium">
                                  Integração Meta configurada com sucesso!
                                </Typography>
                              </Alert>
                            </Grid>
                            <Grid item xs={12}>
                              <Paper elevation={1} sx={{ p: 2, bgcolor: grey[50] }}>
                                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                                  Dados da Configuração:
                                </Typography>
                                <Stack spacing={1}>
                                  <Typography variant="body2">
                                    <strong>NOME DO APP:</strong> {process.env.REACT_APP_META_APP_NAME || 'Não configurado'}
                                  </Typography>
                                  <Typography variant="body2">
                                    <strong>ID DO APP:</strong> {metaData.appId || 'Não configurado'}
                                  </Typography>
                                  <Typography variant="body2">
                                    <strong>Página:</strong> {metaData.page || 'Não configurada'}
                                  </Typography>
                                  <Typography variant="body2">
                                    <strong>ID da Página:</strong> {metaData.pageId || 'Não configurado'}
                                  </Typography>
                                  <Typography variant="body2">
                                    <strong>Formulário:</strong> {metaData.form || 'Não configurado'}
                                  </Typography>
                                  <Typography variant="body2">
                                    <strong>ID do Formulário:</strong> {metaData.formId || 'Não configurado'}
                                  </Typography>
                                  <Typography variant="body2">
                                    <strong>ID/Token do Pixel:</strong> {(metaData.pixelId || 'Não configurado').substring(0, 30)} {metaData.pixelId.length > 30 ? '...' : ''}
                                  </Typography>

                                  <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                                    <Button
                                      variant="outlined"
                                      color="error"
                                      size="small"
                                      onClick={() => setShowRevokeConfirmation(true)}
                                      disabled={isAnyLoading}
                                      startIcon={revokingMeta ? <CircularProgress size={16} /> : <DeleteIcon />}
                                    >
                                      {revokingMeta ? 'Revogando...' : 'Revogar App'}
                                    </Button>
                                  </Box>
                                </Stack>
                              </Paper>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    )
                  )}
                </Box>
              </Grid>
            )}

            {/* MetaRegistrationStepper */}
            {campanha.link && showMetaDetails && showMetaRegistration && (
              <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ mt: 2 }}>
                  <MetaSetupWizard
                    onRegistrationSuccess={handleMetaRegistrationSuccess}
                    onCancel={() => setShowMetaRegistration(false)}
                    existingData={metaData}
                    setMetaData={setMetaData}
                    campanha={campanha}
                    disabled={isAnyLoading}
                  />
                </Box>
              </Grid>
            )}
            {!campanha.link && showMetaDetails && showMetaRegistration && (
              <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ mt: 2 }}>
                  <Alert severity="warning">
                    <Typography variant="body2">
                      Salve a campanha antes de configurar a Integração Meta.
                    </Typography>
                  </Alert>
                </Box>
              </Grid>
            )}

            {/* Informações da Campanha */}
            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
              <Stack spacing={1.5} sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PeopleIcon fontSize="small" sx={{ color: green[700] }} />
                  <Typography variant="body1" fontSize={'12px'}>
                    <strong>Total de Leads:</strong> {campanha.qtd || 0}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CalendarTodayIcon fontSize="small" sx={{ color: blue[700] }} />
                  <Typography variant="body1" fontSize={'12px'}>
                    <strong>Criada em:</strong> {dayjs(campanha.createdat).format('DD/MM/YYYY')}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <WhatsApp fontSize="small" sx={{ color: green[700] }} />
                  <Typography variant="body1" fontSize={'12px'}>
                    <strong>WhatsApp:</strong> {campanha.canwhatsmsg ? 'Sim' : 'Não'}
                  </Typography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions
          sx={{ px: 3, py: 2, bgcolor: grey[100] }}
          // Add inert attribute conditionally
          {...(isAnyLoading ? { inert: 'true' } : {})}
        >
          {!showDelete ? (
            <>
              <Button
                variant="outlined"
                size='small'
                color="error"
                disabled={isAnyLoading}
                onClick={() => setShowDelete(true)}
                startIcon={<DeleteIcon />}
              >
                Deletar
              </Button>
              <Box sx={{ flexGrow: 1 }} />
              <Button
                sx={{
                  ml: 1,
                  bgcolor: changeKnowledge ? red[700] : undefined,
                  '&:hover': {
                    bgcolor: changeKnowledge ? red[800] : undefined,
                  }
                }}
                size='small'
                disabled={isAnyLoading}
                onClick={saveCampanha}
                variant="contained"
                startIcon={savingCampanha ? <CircularProgress size={16} /> : <SaveIcon />}
              >
                {savingCampanha ? 'Salvando...' : 'Salvar'}
              </Button>
              <Button
                disabled={isAnyLoading}
                onClick={handleClose}
                variant="outlined"
                size='small'
              >
                Fechar
              </Button>
            </>
          ) : (
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              width: '100%',
              bgcolor: red[50],
              p: 2,
              borderRadius: 1
            }}>
              <WarningIcon color="error" fontSize="large" />
              <Typography variant="subtitle1" color="error" fontWeight="bold" sx={{ flexGrow: 1 }}>
                Confirmar exclusão desta campanha?
              </Typography>
              <Button
                variant="contained"
                color="error"
                disabled={isAnyLoading}
                onClick={deleteCampanha}
                size='small'
                startIcon={deletingCampanha ? <CircularProgress size={16} /> : <DeleteIcon />}
              >
                {deletingCampanha ? 'Deletando...' : 'Sim, deletar'}
              </Button>
              <Button
                variant="outlined"
                disabled={isAnyLoading}
                onClick={() => setShowDelete(false)}
                size='small'
              >
                Cancelar
              </Button>
            </Box>
          )}
        </DialogActions>
      </Dialog>

      {/* QR Code Dialog */}
      <Dialog
        open={showQrCode && Boolean(link)}  // Convert to boolean to ensure proper prop type
        onClose={() => setShowQrCode(false)}
        aria-labelledby="qrcode-dialog-title"
        aria-describedby="qrcode-dialog-description"
        maxWidth="sm"
        PaperProps={{
          elevation: 3,
          sx: { borderRadius: 2, p: 2 }
        }}
      >
        <DialogTitle
          id="qrcode-dialog-title"
          sx={{
            bgcolor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          QR Code da Campanha
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pt: 3 }}>
          <Box
            sx={{ textAlign: 'center' }}
            id="qrcode-dialog-description"
          >
            {link && (
              <QrCodeGenerator
                initialUrl={`${urlBase}/${link}`}
              />
            )}
            <Typography variant="caption" display="block" sx={{ mt: 2, color: grey[700] }}>
              Escaneie o QR Code com a câmera do seu celular
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowQrCode(false)} variant="contained" fullWidth size='small'>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {openGIMO && (
        <KnowledgeDetail
          user={user}
          places={places}
          setPlaces={setPlaces}
          open={openGIMO}
          handleClose={() => setOpenGIMO(false)}
          setSnackbar={setSnackbar}
          Knowledge={knowledge}
          setKnowledge={setKnowledge}
          setChangeKnowledge={setChangeKnowledge}
        />
      )}

      <Dialog
        open={showRevokeConfirmation}
        onClose={() => setShowRevokeConfirmation(false)}
        aria-labelledby="revoke-confirmation-dialog-title"
        maxWidth="sm"
        PaperProps={{
          elevation: 3,
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle
          id="revoke-confirmation-dialog-title"
          sx={{
            bgcolor: red[50],
            color: red[800],
            fontWeight: 'bold',
            fontSize: '1.25rem',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          <WarningIcon color="error" /> Confirmar Revogação
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 0, px: 3, fontSize: '1rem', }}>
          <Typography variant="body1" gutterBottom mt={2}>
            Você está prestes a revogar a integração do App Meta para esta campanha.
          </Typography>
          <Typography variant="body2" color="error" sx={{ mt: 0, fontWeight: 'medium' }}>
            Esta ação irá:
          </Typography>
          <ul>
            <li>
              <Typography variant="body2">
                Parar a integração automática de leads Meta com o GIMOV
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Remover a inscrição da aplicação da sua página Meta
              </Typography>
            </li>
            <li>
              <Typography variant="body2" color="error">
                <strong>Parar a integração para todas as Campanhas que usam esta página Meta</strong>
              </Typography>
            </li>

          </ul>
          <Typography variant="body2" sx={{ mt: 2, fontWeight: 'bold' }}>
            Esta ação não pode ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, bgcolor: grey[50] }}>
          <Button
            variant="outlined"
            onClick={() => setShowRevokeConfirmation(false)}
            disabled={revokingMeta}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setShowRevokeConfirmation(false);
              revogarApp(metaData.pageId, metaData.accessToken, metaData.formId);
            }}
            startIcon={revokingMeta ? <CircularProgress size={16} /> : <DeleteIcon />}
            disabled={revokingMeta}
          >
            {revokingMeta ? 'Revogando...' : 'Confirmar Revogação'}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}


